export default {
  computed: {
    isDesktop() {
      return this.$store.getters['common/getScreenType'] === 'desktop';
    },
    isTablet() {
      return this.$store.getters['common/getScreenType'] === 'tablet';
    },
    isMobile() {
      return this.$store.getters['common/getScreenType'] === 'mobile';
    },
    isScaDesktop() {
      return this.$store.getters['sca/getScreenType'] === 'desktop';
    },
    isScaTablet() {
      return this.$store.getters['sca/getScreenType'] === 'tablet';
    },
    isScaMobile() {
      return this.$store.getters['sca/getScreenType'] === 'mobile';
    },
  },
};
